export const alias = 'alias';
